import { useCallback } from "react"
import pupa from "pupa"
import { get } from "common/lib/get"
import { usePageProps } from "common/hooks/data/usePageProps"
import type { AppProps } from "common/lib/getAppServerSideProps"
import { usePhraseIceSignedIn } from "./usePhraseIceSignedIn"

export const useTranslations = (scope?: string) => {
  const { translations, phraseIce } = usePageProps<AppProps>()
  // Until login the editor has no translations and shows bare keys in place of markers.
  const phraseMarkers = usePhraseIceSignedIn(!!phraseIce)

  return useCallback(
    (id: string, data?: Record<string, any>) => {
      // Phrase's in-context editor finds copy by this marker, built from the key alone like the Rails gem does.
      if (phraseMarkers) return `{{phrase_${scope ? `${scope}.${id}` : id}}}`

      const scopedTranslations = scope ? get(translations, scope, {}) : translations
      const value: string = get(scopedTranslations, id, id)
      return data ? pupa(value, data, { ignoreMissing: true }) : value
    },
    [translations, scope, phraseMarkers],
  )
}
